import React from 'react';
import FraudPreventionTable from './table/FraudPreventionTable';
import { FraudPreventionUIProvider } from './context/FraudPreventionUIContext';
import ClientDropHeader from '../../clients/makeandchecker/ClientDropHeader';
import ClientsDropMenu from '../../clients/makeandchecker/ClientsDropMenu';

export default function FraudPrevention () {
    const total = { clientsDropBadges: 0 };

    return (
        <FraudPreventionUIProvider>
            <div className='functionalitiesPage'>
                <ClientDropHeader />
                <div className='menuFlex'>
                    <div className='menuFlexLeft'>
                        <ClientsDropMenu clientsDropBadges={total.clientsDropBadges}/>
                    </div>
                    <div className='menuFlexRight'>
                        <FraudPreventionTable />
                    </div>
                </div>
            </div>
        </FraudPreventionUIProvider>
    );
}
